<template>
  <div class="w-[80%] ml-[10%] mt-8 flex flex-row gap-4">
    <LivePrinterCamera :uuid="uuid" />

    <div class="flex flex-col items-start gap-2">
      <div class="flex flex-row gap-2">
        <StatusPrinterChips :statut="localInfo.state?.text"/>
      </div>

      <div class="flex flex-col">
        <BaseKeyValue :cles="t('nozzleTemp')">
          <SimpleText :content="localInfo.temperature.tool0.actual + ' / ' + localInfo.temperature.tool0.target" />
        </BaseKeyValue>

        <BaseKeyValue :cles="t('bedTemp')">
          <SimpleText :content="localInfo.temperature.bed.actual + ' / ' + localInfo.temperature.bed.target" />
        </BaseKeyValue>
      </div>

      <BlueIconButton v-show="isPaused" @click="resumePrinting">
        <WhitePlayIcon />
      </BlueIconButton>

      <MoveAxisesPrinter :uuid="uuid" v-show="!isPrinting && !isPaused"/>
      <UploadToPrinter :uuid="uuid" v-show="isReady" />
      <PrintingInforPrinter :uuid="uuid" :printingInfo="printingInfo" v-show="isPrinting"/>
    </div>
  </div>
</template>

<script setup>

import {computed, defineProps, ref, watch} from "vue";
import LivePrinterCamera from "@/components/molecules/LivePrinterCamera.vue";
import StatusPrinterChips from "@/components/molecules/StatusPrinterChips.vue";
import MoveAxisesPrinter from "@/components/molecules/MoveAxisesPrinter.vue";
import UploadToPrinter from "@/components/molecules/UploadToPrinter.vue";
import {enumeration} from "../../../Enumeration";
import PrintingInforPrinter from "@/components/molecules/PrintingInforPrinter.vue";
import BlueIconButton from "@/components/molecules/BlueIconButton.vue";
import WhitePlayIcon from "@/components/atoms/WhitePlayIcon.vue";
import xhr from "@/utils/xhr";
import {jsonValidator} from "@/utils/JsonValidator";
import {t} from "@/utils/Traduction";
import {NotificationStores} from "@/stores/NotificationStores";
import BaseKeyValue from "@/components/molecules/BaseKeyValue.vue";
import SimpleText from "@/components/atoms/SimpleText.vue";

const props = defineProps({
  uuid: {
    type: String,
    required: true,
  },
  info: {
    type: Object,
    required: true,
  },
  printingInfo: {
    type: Object,
    required: true,
  },
});

const notificationStores = NotificationStores();

const localInfo = ref(props.info);

const isReady = computed(() => {
  return localInfo.value.state?.text === enumeration.statusPrinter.READY ||
         localInfo.value.state?.text === enumeration.statusPrinter.OPERATIONAL;
});

const isPrinting = computed(() => {
  return localInfo.value.state?.text === enumeration.statusPrinter.PRINTING;
});

const isPaused = computed(() => {
  return localInfo.value.state?.text === enumeration.statusPrinter.PAUSED;
});

watch(() => props.info.value, (newInfo) => {
  localInfo.value = newInfo;
}, { immediate: true });


const resumePrinting = () => {
  xhr.addRequestToQueue("POST", "/imprimantes/printing/resume/" + props.uuid, null, true, true, false,
      async (response) => {
        if(response.code !== 200) {

          if(response.code === 0 || !jsonValidator.validate(response.response)) {
            notificationStores.addNotification(
                t("errorDuringServerConnexion"),
                "error");
          } else {
            notificationStores.addNotification(
                JSON.parse(response.response).message,
                "error");
          }
        } else {
          notificationStores.addNotification(
              t("printResumed"),
              "success");
        }
      });
}
</script>

<style scoped>

</style>